import { LandingLoggedInControls } from '@/shared/ui/kit/landing-logged-in-controls';
import { LandingLoginControls } from '@/shared/ui/kit/landing-login-controls';
import { HeaderActionsProps } from '../model/header-actions.props';


export function HeaderActionsLanding ({ profile }: HeaderActionsProps) {
    if (!profile) return (
        <LandingLoginControls/>
    );

    return (
        <LandingLoggedInControls profile={ profile }/>
    )
}
